var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Helpers from './../helpers/utility';
import { deepDiff } from './';
var hasProperties = Helpers.hasProperties;
/**
 * Perform a deepDiff, and return true if there are no differences, or false if there are.
 *
 * @param {object} source The source object
 * @param {any} targets One or more targets to compare
 */
export default function objectsEqual(source) {
    var targets = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        targets[_i - 1] = arguments[_i];
    }
    return !hasProperties(deepDiff.apply(void 0, __spreadArrays([source], targets)));
}
//# sourceMappingURL=objects-equal.js.map